"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformTargetValue = exports.eventStandin = void 0;

var _identity = _interopRequireDefault(require("lodash/identity"));

/**
 * Takes a transform function and sets it for Formik state.
 *
 * @param {function} transformFunc value to transform function
 * @return {function} wrapped handler function
 */
var transformTargetValue = function transformTargetValue() {
  var transformFunc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _identity["default"];
  return function (event, value) {
    var helpers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return helpers.setValue(transformFunc(value));
  };
};
/**
 * When an event is not avaiable for an input
 * this can be used to pass variables and clearly warn the
 * dev if there are expected values that don't exist.
 * @param {Object} mockEvent
 */


exports.transformTargetValue = transformTargetValue;

var eventStandin = function eventStandin(mockEvent) {
  var handler = {
    get: function get(obj, prop) {
      if (prop in obj) {
        return obj[prop];
      }

      throw Error("\n      Olympic lib:\n      This is an event stand in and not the actual input event.\n      The variable or function ".concat(prop, " does not exist.\n      Available variables or functions: ").concat(JSON.stringify(mockEvent, null, 2), "\n     "));
    }
  };
  return new Proxy(mockEvent, handler);
};

exports.eventStandin = eventStandin;